'use client';

import React, { useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';

const PHONE = '098440 68955';
const PHONE_HREF = 'tel:09844068955';

export default function StickyCallBar() {
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const run = async () => {
      const { gsap } = await import('gsap');
      gsap?.fromTo(
        barRef?.current,
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out', delay: 1.2 }
      );
    };
    run();
  }, []);

  return (
    <div data-component-id="src/app/components/StickyCallBar.tsx:25:4" data-component-path="src/app/components/StickyCallBar.tsx" data-component-line="25" data-component-end-line="47" data-component-file="StickyCallBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20bottom-0%20left-0%20right-0%20z-50%20md%3Ahidden%22%7D"
      ref={barRef}
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden"
      style={{ opacity: 1 }}
    >
      <div data-component-id="src/app/components/StickyCallBar.tsx:30:6" data-component-path="src/app/components/StickyCallBar.tsx" data-component-line="30" data-component-end-line="46" data-component-file="StickyCallBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%20border-t%20border-border%20shadow-2xl%20px-4%20py-3%20flex%20items-center%20gap-3%22%7D" className="bg-white border-t border-border shadow-2xl px-4 py-3 flex items-center gap-3">
        <a data-component-id="src/app/components/StickyCallBar.tsx:31:8" data-component-path="src/app/components/StickyCallBar.tsx" data-component-line="31" data-component-end-line="37" data-component-file="StickyCallBar.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%5Bvar%3APHONE_HREF%5D%22%2C%22className%22%3A%22flex-1%20btn-primary%20justify-center%20text-base%20py-3.5%20rounded-xl%20animate-pulse-cta%22%2C%22textContent%22%3A%22098440%2068955%22%7D"
          href={PHONE_HREF}
          className="flex-1 btn-primary justify-center text-base py-3.5 rounded-xl animate-pulse-cta"
        >
          <Icon data-component-id="src/app/components/StickyCallBar.tsx:35:10" data-component-path="src/app/components/StickyCallBar.tsx" data-component-line="35" data-component-end-line="35" data-component-file="StickyCallBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22PhoneIcon%22%7D" name="PhoneIcon" size={20} variant="solid" />
        098440 68955
        </a>
        <a data-component-id="src/app/components/StickyCallBar.tsx:38:8" data-component-path="src/app/components/StickyCallBar.tsx" data-component-line="38" data-component-end-line="45" data-component-file="StickyCallBar.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%5Bvar%3APHONE_HREF%5D%22%2C%22className%22%3A%22flex-shrink-0%20flex%20flex-col%20items-center%20text-primary%20hover%3Atext-accent%20transition-colors%22%7D"
          href={PHONE_HREF}
          className="flex-shrink-0 flex flex-col items-center text-primary hover:text-accent transition-colors"
          aria-label={`Call ${PHONE}`}
        >
          {/* <Icon name="PhoneArrowUpRightIcon" size={22} variant="outline" className="text-primary" />
          <span className="text-[10px] font-bold mt-0.5 text-muted-foreground">CALL</span> */}
        </a>
      </div>
    </div>
  );
}